import {
  getProgressProps
} from "./chunk-I2KZZIX3.mjs";
import {
  spin
} from "./chunk-ONZLO3HG.mjs";

// src/circular/usecase/use-circle-progress-style.ts
function useCircleProgressStyle({
  min,
  max,
  value,
  valueText,
  getValueText,
  isIndeterminate
}) {
  var _a;
  const progress = getProgressProps({
    min,
    max,
    value,
    valueText,
    getValueText,
    isIndeterminate
  });
  const determinant = isIndeterminate ? void 0 : ((_a = progress.percent) != null ? _a : 0) * 2.64;
  const strokeDasharray = determinant == null ? void 0 : `${determinant} ${264 - determinant}`;
  const indicatorProps = isIndeterminate ? {
    css: { animation: `${spin} 1.5s linear infinite` }
  } : {
    strokeDashoffset: 66,
    strokeDasharray,
    transitionProperty: "stroke-dasharray, stroke",
    transitionDuration: "0.6s",
    transitionTimingFunction: "ease"
  };
  return { indicatorProps, progress };
}
var use_circle_progress_style_default = useCircleProgressStyle;

export {
  use_circle_progress_style_default
};
